import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import './Styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/base/AuthProvider';
import { LoadingProvider } from './components/base/LoadingProvider';
import { ContextProvider } from './components/base/ContextProvider';
import { UserProvider } from './components/base/UserProvider';
import { WhatsappSessionsProvider } from './components/base/WhatsappSessionsProvider';
import { applyBrandingToDocument, createAppTheme } from './config/branding';

applyBrandingToDocument();
const appTheme = createAppTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <AuthProvider>
        <LoadingProvider>
          <ContextProvider>
            <UserProvider>
              <App />
            </UserProvider>
          </ContextProvider>
        </LoadingProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))